
import FindPartner from "../../components/landing/searсh-on-xxx-websites/find-partner";
import QuotesBlock from "../../components/landing/searсh-on-xxx-websites/quotes-block";
import ServiceFor from "../../components/landing/searсh-on-xxx-websites/service-for";
import HowWeDo from "../../components/landing/searсh-on-xxx-websites/how-we-do";
import SitesScan from "../../components/landing/searсh-on-xxx-websites/sites-scan";
import blog from "../../components/landing/blog";
import Waiting from "../../components/landing/searсh-on-xxx-websites/waiting";
import Results from "../../components/landing/searсh-on-xxx-websites/results";
import Steps from "../../components/landing/searсh-on-xxx-websites/steps";
import RealStories from "../../components/landing/searсh-on-xxx-websites/real-stories.vue";
import Featured from "../../components/landing/searсh-on-xxx-websites/featured";
import Mission from "../../components/landing/searсh-on-xxx-websites/mission";
import AlreadyUsing from "../../components/landing/searсh-on-xxx-websites/already-using";
import Comments from "../../components/landing/searсh-on-xxx-websites/comments.vue";
import Overcoming from "../../components/landing/searсh-on-xxx-websites/overcoming";
import Faq from "../../components/landing/searсh-on-xxx-websites/faq";
import QuotesBlockKnowledge from "../../components/landing/searсh-on-xxx-websites/quotes-block-knowledge";
import Navigation from '../../components/Navigation.vue';
import FooterMain from '../../components/FooterMain.vue';

import isMob from "@/mixins/isMob";
import authorization from "@/mixins/authorization";

export default {
  mixins: [isMob, authorization],
  mounted() {
    this.getUtm()
  },
  components: {
    FindPartner,
    QuotesBlock,
    ServiceFor,
    HowWeDo,
    blog,
    SitesScan,
    Waiting,
    Results,
    Steps,
    RealStories,
    Featured,
    Mission,
    AlreadyUsing,
    Comments,
    Overcoming,
    Faq,
    QuotesBlockKnowledge,
    Navigation,
    FooterMain,
  },
  head() {
    const title = 'Cheater Finder Tool: Instantly Search XXX & Adult Sites for Hidden Activity | iFindCheaters';
    const description = 'Suspect infidelity? iFindCheaters scans 50+ adult platforms to uncover secret profiles and activity. Discover the truth in minutes and regain peace of mind with our discreet, user-friendly tool.';

    return {
      title: title,
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        { hid:'og:title', property: 'og:title', content: title },
        { hid: "description", name: "description", content: description },
        { hid: "og:description", name: "og:description", content: description },
        { hid: 'og:image',  property: 'og:image', content: '/products/find-someone-cheating-online-for-free/og.png' },
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        { hid:'og:site_name', property: 'og:site_name', content: 'ifindcheaters.com' },
        { hid: 'og:keywords', name: 'og:keywords', content: 'secret profile finder, search people on dating sites, search for someone on dating sites, search dating profiles, is my husband on dating sites, find hidden dating profiles, find my wife on dating sites, catch a cheating spouse, find spouse on dating sites, Catch cheating partner online, Online infidelity search, find out if my boyfriend or girlfriend is on dating sites, how to find spouse on dating sites, is my wife on dating sites or apps, free dating profiles search by email' }

      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/products/search-on-xxx-websites/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Products",
              "item": "https://ifindcheaters.com/products/"
            },{
              "@type": "ListItem",
              "position": 3,
              "name": "Search your cheating spouse on XXX and Adult Sites"
            }]
          }
        },{
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": "Search your cheating spouse on XXX and Adult Sites",
            "sku": "006",
            "image": "https://ifindcheaters.com/img/logo.png",
            "description": description,
            "brand": {
              "@type": "Brand",
              "name": "iFindCheaters"
            },
              "offers": {
              "@type": "Offer",
              "url": "https://ifindcheaters.com/products/search-on-xxx-websites/",
              "priceCurrency": "USD",
              "price": "14.99",
              "priceValidUntil": "2022-05-25",
              "itemCondition": "https://schema.org/UsedCondition",
              "availability": "https://schema.org/InStock",
              "seller": {
              "@type": "Organization",
              "name": "iFindCheaters"
              }},
              "review": [{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "4.5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Amy4u"
              },
              "datePublished": "2021-09-05T16:08:30+00:00",
              "reviewBody": "Seems too good to be true? Check that out. Better safe than sorry!"
            },{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "4.5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Amanda102"
              },
            "datePublished": "2020-11-09T16:35:29+00:00",
            "reviewBody": "It was such a relief that you can buy just 1 search credit and use it however you want. No obligation or pressure."
            }],
              "aggregateRating": {
              "@type": "AggregateRating",
              "bestRating": "5",
              "ratingValue": "4.6",
              "reviewCount": "79"
              }
            }
          }
      ]
    }
  },
};
